<!-- WIDGET só exibe se tiver permissão -->
<div class="fuse-widget-front" *ngIf="hasPermission">
    <div class="simple-table-container" ms-responsive-table>
        <div
            class="table-title font-size-16 light-blue-600"
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span data-testid="boletas-widget-title"
                >Boletas de Intermediação - Resumo</span
            >
            <button
                mat-icon-button
                fuseWidgetToggle
                aria-label="Ver lista completa"
                style="float: right"
                (click)="redirectToFullList()"
                matTooltip="Ver lista completa"
                data-testid="redirect-button"
            >
                <mat-icon class="logo-icon s-24 mr-8">launch</mat-icon>
            </button>
        </div>

        <!-- Loading Indicator -->
        <div
            *ngIf="loadingIndicator"
            class="loading-container p-16"
            style="text-align: center"
        >
            <mat-spinner diameter="30"></mat-spinner>
            <span style="margin-left: 8px" data-testid="loading-indicator"
                >Carregando...</span
            >
        </div>

        <!-- Tabela de Boletas -->
        <ngx-datatable
            #table
            class="material striped expandable-table"
            [loadingIndicator]="loadingIndicator"
            [messages]="{
                emptyMessage: 'Nenhuma boleta encontrada',
                totalMessage: 'total'
            }"
            [columnMode]="ColumnMode.flex"
            [headerHeight]="40"
            [footerHeight]="0"
            [rowHeight]="40"
            [rows]="rows"
            [scrollbarV]="false"
            [scrollbarH]="true"
            *ngIf="!loadingIndicator"
            data-testid="boletas-widget-table"
        >
            <!-- Descrição do Ativo -->
            <ngx-datatable-column
                name="Descrição do Ativo"
                prop="cliente_vendedor.ativo.descricao"
                [flexGrow]="2"
                [minWidth]="150"
                [sortable]="false"
            >
                <ng-template
                    let-rowIndex="rowIndex"
                    let-row="row"
                    ngx-datatable-cell-template
                >
                    <span
                        style="font-size: 12px; font-weight: 500"
                        [title]="displayFnDescricaoAtivo(row)"
                        >{{ displayFnDescricaoAtivo(row) }}</span
                    >
                </ng-template>
            </ngx-datatable-column>

            <!-- Taxa -->
            <ngx-datatable-column
                name="Taxa"
                prop="cliente_vendedor.ativo.taxa_indexada"
                [flexGrow]="1.5"
                [minWidth]="32"
                [sortable]="false"
            >
                <ng-template
                    let-rowIndex="rowIndex"
                    let-value="value"
                    ngx-datatable-cell-template
                >
                    <span style="font-size: 12px" [title]="value">{{
                        value
                    }}</span>
                </ng-template>
            </ngx-datatable-column>

            <!-- Vencimento -->
            <ngx-datatable-column
                name="Vencimento."
                prop="cliente_vendedor.ativo.data_vencimento"
                [flexGrow]="1"
                [minWidth]="80"
                [sortable]="false"
            >
                <ng-template
                    let-rowIndex="rowIndex"
                    let-value="value"
                    ngx-datatable-cell-template
                >
                    <span style="font-size: 12px">{{ value }}</span>
                </ng-template>
            </ngx-datatable-column>

            <!-- Quantidade -->
            <ngx-datatable-column
                name="Quantidade"
                prop="quantidade_venda"
                [flexGrow]="1"
                [minWidth]="80"
                [sortable]="false"
            >
                <ng-template
                    let-rowIndex="rowIndex"
                    let-value="value"
                    ngx-datatable-cell-template
                >
                    <span style="font-size: 12px">{{ value }}</span>
                </ng-template>
            </ngx-datatable-column>

            <!-- Total -->
            <ngx-datatable-column
                name="Total"
                [flexGrow]="0.8"
                [minWidth]="70"
                [sortable]="false"
            >
                <ng-template
                    let-rowIndex="rowIndex"
                    let-row="row"
                    ngx-datatable-cell-template
                >
                    <span style="font-size: 12px">
                        {{
                            row.quantidade_venda *
                                row.cliente_vendedor?.ativo?.valor_unitario
                                | number : "1.0-0"
                        }}
                    </span>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>

        <!-- Paginação -->
        <div
            style="padding: 8px 16px; border-top: 1px solid #e0e0e0"
            *ngIf="!loadingIndicator && rows.length > 0"
        >
            <mat-paginator
                #paginator
                [length]="length"
                [pageSize]="params.per_page"
                [pageSizeOptions]="[5, 10]"
                [pageIndex]="params.page - 1"
                (page)="onPageEvent($event)"
                style="padding: 0"
                data-testid="boletas-widget-paginator"
            >
            </mat-paginator>
        </div>
    </div>
</div>
